<div class="card bg-dark-lighter text-white wallet-setting">
  <div class="card-body">
    <form class="form form-horizontal" #form="ngForm" (ngSubmit)="save()">
      <div class="mb-4">
        <p-fieldset legend="FIAT" [transitionOptions]="'0ms'">
          <div class="row">
            <div class="col-xl-3 col-lg-6 br">
              <div class="row mb-3">
                <div class="col text-red">MIN WITHDRAW</div>
              </div>
              <div class="row mb-3">
                <label class="control-label col-auto">USD</label>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="minwdUSD"
                      [(ngModel)]="data.fiat.usd.minwd"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <label class="control-label col-auto">JPY</label>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="minwdJPY"
                      [(ngModel)]="data.fiat.jpy.minwd"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6">
              <div class="row mb-3">
                <div class="col text-red">MAX WITHDRAW</div>
              </div>
              <div class="row mb-3">
                <label class="control-label col-auto">USD</label>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="maxwdUSD"
                      [(ngModel)]="data.fiat.usd.maxwd"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <label class="control-label col-auto">JPY</label>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="maxwdJPY"
                      [(ngModel)]="data.fiat.jpy.maxwd"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-fieldset>
      </div>
      <div class="mb-4">
        <p-fieldset legend="DEPOSIT WITHDRAW FEE" [transitionOptions]="'0ms'">
          <div class="row mb-3">
            <div class="col-xl-3 col-lg-6">
              <div class="row mb-3">
                <div class="col text-red">MIN DEPOSIT</div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">USD</div>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="minDeposit"
                      [(ngModel)]="data.common.usd.minDeposit"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">JPY</div>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="jpyminDeposit"
                      [(ngModel)]="data.common.jpy.minDeposit"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-xl-3 col-lg-6">
              <div class="row mb-3">
                <div class="col text-red">DEPOSIT THRESHOLD</div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">USD</div>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="depositThreshold"
                      [(ngModel)]="data.common.usd.depositThreshold"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">JPY</div>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="jpydepositThreshold"
                      [(ngModel)]="data.common.jpy.depositThreshold"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6">
              <div class="row mb-3">
                <div class="col text-red">DEPOSIT FEE</div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">USD</div>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="depositCharge"
                      [(ngModel)]="data.common.usd.depositCharge"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">JPY</div>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="jpydepositCharge"
                      [(ngModel)]="data.common.jpy.depositCharge"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-3 col-lg-6">
              <div class="row mb-3">
                <div class="col text-red">WITHDRAW THRESHOLD</div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">USD</div>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="withdrawThreshold"
                      [(ngModel)]="data.common.usd.withdrawThreshold"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="control-label col-auto">JPY</div>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="jpywithdrawThreshold"
                      [(ngModel)]="data.common.jpy.withdrawThreshold"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6">
              <div class="row mb-3">
                <div class="col text-red">WITHDRAW FEE</div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">USD</div>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="withdrawCharge"
                      [(ngModel)]="data.common.usd.withdrawCharge"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="control-label col-auto">JPY</div>
                <div class="col">
                  <div class="input-group">
                    <input
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="jpywithdrawCharge"
                      [(ngModel)]="data.common.jpy.withdrawCharge"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-fieldset>
      </div>
      <div class="mb-4">
        <p-fieldset legend="STICPAY FEE" [transitionOptions]="'0ms'">
          <div class="row">
            <div class="col-xl-3 col-lg-6">
              <div class="row mb-3">
                <div class="col text-red">MIN DEPOSIT</div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">USD</div>
                <div class="col">
                  <div class="input-group">
                    <fx-input-number
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="sticpayminDeposit"
                      [(ngModel)]="data.sticpay.usd.minDeposit"
                      [min]="0"
                      [precision]="2"
                      required
                    ></fx-input-number>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">JPY</div>
                <div class="col">
                  <div class="input-group">
                    <fx-input-number
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="sticpayjpyminDeposit"
                      [(ngModel)]="data.sticpay.jpy.minDeposit"
                      [min]="0"
                      required
                    ></fx-input-number>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6">
              <div class="row mb-3">
                <div class="col text-red">DEPOSIT THRESHOLD</div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">USD</div>
                <div class="col">
                  <div class="input-group">
                    <fx-input-number
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="sticpaydepositThreshold"
                      [(ngModel)]="data.sticpay.usd.depositThreshold"
                      [precision]="2"
                      [min]="0"
                      required
                    ></fx-input-number>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">JPY</div>
                <div class="col">
                  <div class="input-group">
                    <fx-input-number
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="sticpayjpydepositThreshold"
                      [(ngModel)]="data.sticpay.jpy.depositThreshold"
                      [min]="0"
                      required
                    ></fx-input-number>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6">
              <div class="d-flex mb-3 justify-content-between">
                <div class="text-red">TRANSACTION FEE</div>
                <div class="cursor-pointer" (click)="changeTransactionFeeModeOnClick()">
                  <span>{{data?.sticpay?.transactionFeeMode === 'amount' ? 'BY RATIO': 'BY AMOUNT'}}</span>
                  <span>&nbsp;</span>
                  <i class="fa fa-exchange"></i>
                </div>
              </div>
              <ng-container *ngIf="data?.sticpay?.transactionFeeMode === 'amount';else ratioTemplate">
                <div class="row mb-3">
                  <div class="col-auto control-label">USD</div>
                  <div class="col">
                    <div class="input-group">
                      <fx-input-number
                        type="number"
                        [readonly]="!permission.allowUpdating"
                        class="form-control bg-dark"
                        name="sticpaytransactionFeeAmount"
                        [precision]="2"
                        [(ngModel)]="data.sticpay.usd.transactionFeeAmount"
                        [min]="0"
                        required
                      ></fx-input-number>
                      <span class="input-group-text bg-dark border-0 text-white">$</span>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-auto control-label">JPY</div>
                  <div class="col">
                    <div class="input-group">
                      <fx-input-number
                        type="number"
                        [readonly]="!permission.allowUpdating"
                        class="form-control bg-dark"
                        name="sticpayjpytransactionFeeAmount"
                        [(ngModel)]="data.sticpay.jpy.transactionFeeAmount"
                        [min]="0"
                        required
                      ></fx-input-number>
                      <span class="input-group-text bg-dark border-0 text-white">¥</span>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #ratioTemplate>
                <div class="row mb-3">
                  <div class="col-auto control-label">USD</div>
                  <div class="col">
                    <div class="input-group">
                      <fx-input-number
                        type="number"
                        [readonly]="!permission.allowUpdating"
                        class="form-control bg-dark"
                        name="sticpaytransactionFeeRatio"
                        [precision]="2"
                        [(ngModel)]="data.sticpay.usd.transactionFeeRatio"
                        [min]="0"
                        [max]="100"
                        required
                      ></fx-input-number>
                      <span class="input-group-text bg-dark border-0 text-white">%</span>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-auto control-label">JPY</div>
                  <div class="col">
                    <div class="input-group">
                      <fx-input-number
                        type="number"
                        [readonly]="!permission.allowUpdating"
                        class="form-control bg-dark"
                        name="sticpayjpytransactionFeeRatio"
                        [precision]="2"
                        [(ngModel)]="data.sticpay.jpy.transactionFeeRatio"
                        [min]="0"
                        [max]="100"
                        required
                      ></fx-input-number>
                      <span class="input-group-text bg-dark border-0 text-white">%</span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
            <div class="col-xl-3 col-lg-6">
              <div class="row mb-3">
                <div class="col text-red">STICPAY FEE</div>
              </div>
              <div class="row mb-3">
                <div class="col-auto control-label">USD</div>
                <div class="col">
                  <div class="input-group">
                    <fx-input-number
                      type="number"
                      [readonly]="!permission.allowUpdating"
                      class="form-control bg-dark"
                      name="sticpayFee"
                      [precision]="2"
                      [(ngModel)]="data.sticpay.usd.sticpayFee"
                      [min]="0"
                      [max]="100"
                      required
                    ></fx-input-number>
                    <span class="input-group-text bg-dark border-0 text-white">%</span>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="control-label col-auto">JPY</div>
                <div class="col">
                  <div class="input-group">
                    <fx-input-number
                    type="number"
                    [readonly]="!permission.allowUpdating"
                    class="form-control bg-dark"
                    name="jpysticpayFee"
                    [precision]="2"
                    [(ngModel)]="data.sticpay.jpy.sticpayFee"
                    [min]="0"
                    [max]="100"
                    required
                    ></fx-input-number>
                    <span class="input-group-text bg-dark border-0 text-white">%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-fieldset>
      </div>
      <div class="row mt-3">
        <div class="col-12" edit-permission>
          <button type="submit" class="btn btn-primary pull-right btn-settings">
            Apply
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
